export class QStream {
  constructor() {
    this.fStreamBuffer = null;
  }

  InitStream() {
    this.fStreamBuffer = [];
  }

  InitStreamFromXML(xmlData) {
    this.fStreamBuffer = xmlData.split("\n");
  }

  Write(theString) {
    this.fStreamBuffer.push(theString);
  }

  StreamStringCount() {
    return this.fStreamBuffer.length;
  }

  GetIndexString(index) {
    return this.fStreamBuffer[index];
  }

  JoinStream() {
    var jStream = this.fStreamBuffer.join("\n");
    return jStream;
  }

  JoinStream2() {
    var jStream = this.fStreamBuffer.join("\n");
    this.fStreamBuffer = null;
    return jStream;
  }

  JoinStream3() {
    var jStream = this.fStreamBuffer.join("");
    this.fStreamBuffer = null;
    return jStream;
  }

  StreamLen() {
    return this.fStreamBuffer.length;
  }

  TruncateSteam(newLength) {
    this.fStreamBuffer.length = newLength;
  }

  LogToConsole() {
    console.log("===========================");

    var n = this.fStreamBuffer.length;
    console.log("Number of lines: ", n);
    for (var i = 0; i < n; i++) {
      var theString = this.fStreamBuffer[i];
      console.log(theString);
    }

    console.log("===========================");
  }
}
